import { Component, OnInit } from '@angular/core';
import { RedirectFbService } from '../../../../services/redirect-fb/redirect-fb.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-validation-mail',
  templateUrl: './validation-mail.component.html',
  styleUrls: ['./validation-mail.component.css']
})
export class ValidationMailComponent implements OnInit {

  currEmail: string|any;

  constructor(
    private fbServ: RedirectFbService,
    private router: Router
  ) { }

  ngOnInit() {
   
    this.currEmail = this.fbServ.parseEmail();
    this.fbServ.validMail();
  }

  goHome() {
    this.router.navigate(["/home"]);
  }

}
